import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../controls/Modal';

const MAX_SCORE = 30;

// Модалка завершения спортивного события: степпер счёта + определение победителя.
export default function FinishSportModal({ event, onSubmit, onClose }) {
    const { team1, team2 } = event;
    const [score, setScore] = useState([0, 0]);

    const step = (idx, delta) => setScore(prev => {
        const next = [...prev];
        next[idx] = Math.max(0, Math.min(MAX_SCORE, next[idx] + delta));
        return next;
    });

    let winnerName = 'Ничья';
    let winTeamId = null;
    if (score[0] > score[1]) { winnerName = team1.name; winTeamId = team1.teamId; }
    else if (score[1] > score[0]) { winnerName = team2.name; winTeamId = team2.teamId; }

    const submit = async () => {
        try {
            await onSubmit(event.id, `${score[0]}:${score[1]}`, winTeamId);
            onClose();
        } catch (e) { /* ошибку покажет хук */ }
    };

    return (
        <Modal
            open
            kicker="Спортивное событие"
            title={`Завершить · ${team1.name} vs ${team2.name}`}
            onClose={onClose}
            footer={(
                <>
                    <button type="button" className="btn btn-ghost" onClick={onClose}>Отмена</button>
                    <button type="button" className="btn btn-primary" onClick={submit}>Завершить событие</button>
                </>
            )}
        >
            <div>
                <div className="se-grid">
                    <div className="se-col">
                        <div className="se-team">{team1.name}</div>
                        <div className="se-stepper">
                            <button type="button" onClick={() => step(0, -1)}>−</button>
                            <b>{score[0]}</b>
                            <button type="button" onClick={() => step(0, 1)}>+</button>
                        </div>
                    </div>
                    <div className="se-vs">:</div>
                    <div className="se-col">
                        <div className="se-team">{team2.name}</div>
                        <div className="se-stepper">
                            <button type="button" onClick={() => step(1, -1)}>−</button>
                            <b>{score[1]}</b>
                            <button type="button" onClick={() => step(1, 1)}>+</button>
                        </div>
                    </div>
                </div>
                <div className="se-out">Победитель: <b>{winnerName}</b></div>
                <div className="se-hint">Итоговый счёт определит выигравшие ставки</div>
            </div>
        </Modal>
    );
}

FinishSportModal.propTypes = {
    event: PropTypes.shape({
        id: PropTypes.number.isRequired,
        team1: PropTypes.object.isRequired,
        team2: PropTypes.object.isRequired
    }).isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};
